<template>
    <div>
        <van-nav-bar
                title="支付结果"
        />
        <div class="result" v-if="states">
          <van-icon v-if="isSuccess" name="success" size="80" color="green"/>
          <van-icon v-if="!isSuccess" name="cross" size="80" color="red"/><br>
          <span>{{result}}</span>
        </div>
        <div style="top: 50px;">
          <van-button plain type="info" style="margin: 15px auto">立即开票</van-button>
          <van-button plain type="info" style="margin: 15px auto;" @click="goHome">返回首页</van-button>
        </div>
    </div>
</template>

<script>
import {Button, Icon, NavBar, Toast} from 'vant'

export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Icon.name]: Icon
  },
  data() {
    return {
      result:'查询中',
      isSuccess:true,
      orderSn:'',
      states: true
    };
  },
  created() {
    // // let that = this;
    // // let tempNum = 0;
    // let state = this.$route.query.orderCode
    // setInterval(() => {
    //   this.$axios
    //       .get(url)
    //       .then(data => {
    //         this.hotList = data;
    //       })
    //       .catch(erro => {
    //         reject(erro);
    //       });
    //   }, 3000)
    // },


              // that.getPackData(that.orderId).then(res => {
              //   //支付宝和微信都去查找一次
              //   if (res.success) {
              //     that.payState = "1";
              //     sessionStorage.removeItem('paytips');
              //     clearInterval(that.tempTime);
              //   } else {
              //     tempNum ++;
              //     if(tempNum > 3){
              //       that.payState = "2"; //显示支付失败
              //       clearInterval(that.tempTime);
              //     }
              //   }
              // });

    // // that.orderId = this.$route.params.orderNO;
    // // that.payType = this.$route.params.payType;
    // // that.getCodePaySession();
    // if (state === "error") {
    //   that.payState = "2";
    // }
    // else if (that.payType === 1){
    //   // 福分支付
    //   setTimeout(() => {
    //     that.payState = state === 'success' ? '1' : '2';
    //   },2000)
    // }
    // else {
    //   // 支付宝和微信支付
    //   that.tempTime = setInterval(() => {
    //     that.getPackData(that.orderId).then(res => {
    //       //支付宝和微信都去查找一次
    //       if (res.success) {
    //         that.payState = "1";
    //         sessionStorage.removeItem('paytips');
    //         clearInterval(that.tempTime);
    //       } else {
    //         tempNum ++;
    //         if(tempNum > 3){
    //           that.payState = "2"; //显示支付失败
    //           clearInterval(that.tempTime);
    //         }
    //       }
    //     });
    //   }, 3000)
    // }
  },
  mounted() {
    this.init()
  },
  // {
  //   init() {
  //     const orderSn = this.$route.params.orderSn
  //     this.orderSn = orderSn
  //     // payApi.queryResult(orderSn).then(res => {
  //     //   if(res.data === true){
  //     //     this.result="支付成功"
  //     //     this.isSuccess = true
  //     //   }else{
  //     //     this.isSuccess = false
  //     //     this.result="支付失败"
  //     //   }
  //     // })
  //     this.result="支付成功"
  //   },
  //   goHome(){
  //     this.$router.push('/home')
  //   },
  //   toIndex(){
  //     this.$router.push('/index')
  //   },
  //   toOrder(){
  //     this.$router.push('/order/detail/'+this.orderSn)
  //   }
  // }
}

</script>

<style lang="less">
    .result {
        margin-top:10%;
        text-align: center;
    }


</style>
